import { useQuery } from '@apollo/client';
import { GET_MY_ROLES_AND_CURRENT_USER_ROLE } from '../gql/auth';
import { SCOPE_TYPES } from 'constants/scopes';

const useViewProjectApplication = () => {
  const { data, loading } = useQuery(GET_MY_ROLES_AND_CURRENT_USER_ROLE);
  if (data && !loading) {
    const scope = data?.myCurrentUserRole?.role?.scopes.find(
      (item) => item.type === SCOPE_TYPES.VIEW_PROJECT_APPLICATION
    );
    const level = scope?.level;
    switch (level) {
      case 'ALL':
        return {
          loading: false,
          level: scope.level,
          department: null,
          faculty: null,
        };
      case 'FACULTY':
        return {
          loading: false,
          level: scope.level,
          department: null,
          faculty: data?.myCurrentUserRole?.faculty?.id,
        };
      case 'DEPARTMENT':
        return {
          loading: false,
          level: scope.level,
          department: data?.myCurrentUserRole?.department?.id,
          faculty: data?.myCurrentUserRole?.faculty?.id,
        };
      default:
        return {
          loading: true,
          level: null,
          department: null,
          faculty: null,
        };
    }
  }

  return {
    loading: true,
    level: null,
    department: null,
    faculty: null,
  };
};

export default useViewProjectApplication;
